import Vue from 'vue'
import dayjs from 'dayjs'

require('dayjs/locale/fr-ca')
const localizedFormat = require('dayjs/plugin/localizedFormat')
dayjs.locale('fr-ca')
dayjs.extend(localizedFormat)

const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('America/Montreal')

const updateLocale = require('dayjs/plugin/updateLocale')
const calendar = require('dayjs/plugin/calendar')
dayjs.extend(updateLocale)
dayjs.extend(calendar)
dayjs.updateLocale('fr-ca', {
    calendar: {
        lastDay: '[hier à] LT',
        sameDay: "[aujourd'hui à] LT",
        nextDay: '[demain à] LT',
        lastWeek: 'dddd [dernier à] LT',
        nextWeek: 'dddd [à] LT',
        sameElse: '[le] D MMMM YYYY [à] HH[h]mm',
    },
    formats: {
        l: 'D/M/YYYY',
        ll: 'D MMM YYYY',
        lll: 'D MMM YYYY, H:mm',
        llll: 'ddd MMM D YYYY, H[:]mm',
    },
})

export default Vue.mixin({
    created: function () {
        this.$date = dayjs
    },
})
